import React from 'react';

import './Login.css';
import Hosts from '../../Hosts'

import {

	repo_logo_link,
	repo_img_link,

} from '../../Utils';


// or
//import { Tabs } from '@material-ui/core';
import RegistForm from "./RegistForm";

const Regist = () => {
  return (
    <div id="regist" className="container-fluid" style={{
        backgroundImage: `url(` + repo_img_link("concrete_seamless.png") + `)`,
        backgroundRepeat: 'repeat',
        backgroundPosition: 'top center',
        backgroundAttachment: 'fixed',
        backgroundColor: '#f7f7f7'
      }}>
        <div className="row">
          <div className='col-12'>
            <div className='container'>
              <div className="row">
                <div className='col-12'>

                  <div className="form-header text-center">
                    <a href={Hosts.WEB_SITE_URI} rel="noreferrer" target="_blank">
                      <img alt='' src={repo_logo_link("logo.svg")}  style={{width: '180px'}} />      
                    </a>      
                  </div>

                  <div className="div-form">
                    <div className='row'>
                      <RegistForm />            
                    </div>
                  </div>

                  <div className="form-footer">

                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </div>

  );

}

export default Regist;

